/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Reports_Body2Inputs */

const ja_playdata_home_reports_body2 = /** @type {(inputs: Playdata_Home_Reports_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公式チャンネルからミラー配信、競合分析まで、幅広くカバーしています。`)
};

const en_playdata_home_reports_body2 = /** @type {(inputs: Playdata_Home_Reports_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From official channels, to mirror broadcasts and competitor analysis, we have you covered.`)
};

/**
* | output |
* | --- |
* | "From official channels, to mirror broadcasts and competitor analysis, we have you covered." |
*
* @param {Playdata_Home_Reports_Body2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_reports_body2 = /** @type {((inputs?: Playdata_Home_Reports_Body2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Reports_Body2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_reports_body2(inputs)
	return en_playdata_home_reports_body2(inputs)
});